import React from "react";
import "./TeamMember.css";
import EmailIcon from "./email.svg";
import PhoneIcon from "./phone.svg";

const TeamMember = (props) => {
  return (
    <div className="TeamMember">
      <a className="member-photo" href={`/team/${props.slug}`}>
        <img className="profile-img" src={props.img} alt={props.name}></img>
      </a>
      <div className="member-data">
        <div className="name">{props.name}</div>
        <div className="title">{props.title}</div>
        <div className="contact-pill-group">
          <a
            className="contact-pill"
            href={`mailto:${props.email}`}
            aria-label={`Email ${props.name}`}
          >
            <img src={EmailIcon} alt="" className="contact-icon" />
            <span className="sr-only">Email {props.name}</span>
          </a>
          <a
            className="contact-pill"
            href={`tel:${props.phone}`}
            aria-label={`Call ${props.name}`}
          >
            <img src={PhoneIcon} alt="" className="contact-icon" />
            <span className="sr-only">Call {props.name}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TeamMember;
